// Datos y cálculos compartidos por Editar espacio y Editar varios.
// Las claves son las columnas de `alojamiento` (las mismas que manda el
// wizard viejo a accommodations/update). Los textos visibles salen de
// `editor_espacio.*` (scripts/i18n-editor-espacio.js) o de `wizard.*`.
import categorias from '@/components/Banner/Category.json';

export const MODALIDADES = ['mensual', 'diario', 'ambos'];
export const GARANTIA_MESES = [0, 0.5, 1, 1.5, 2];
export const GARANTIA_PAGO = ['30_dias_antes', '15_dias_antes', '5_dias_antes', 'check_in', 'hasta_5_dias_despues'];

// Comodidades (step4-data.json), en grupos. [columna, texto (wizard.s4.*), ícono]
export const COMODIDADES = [
    { grupo: 'edificio', items: [
        ['conserje', 'concierge', 'key'], ['timbre', 'doorbell', 'bell'], ['bodega', 'cellar', 'box'],
        ['estacionamiento_privado', 'private-parking', 'car'], ['estacionamiento_visita', 'parking-visit', 'car'],
        ['estacionamiento_bicicleta', 'bicycle-parking', 'bike'], ['sala_eventos', 'event-hall', 'party'],
        ['jardines', 'gardens', 'leaf'], ['piscina', 'swimming-pool', 'wave'], ['gimnasio_interno', 'internal-gym', 'gym'],
    ] },
    { grupo: 'cocina', items: [
        ['cocina', 'kitchen', 'pot'], ['refrigerador', 'fridge', 'fridge'], ['microondas', 'microwave-oven', 'micro'],
        ['horno', 'oven', 'oven'], ['parrilla', 'grill', 'grill'], ['desayuno', 'breakfast', 'cup'],
    ] },
    { grupo: 'lavado', items: [
        ['lavadora', 'washing-machine', 'wash'], ['secadora', 'dryer', 'wash'], ['plancha', 'iron', 'iron'], ['limpieza', 'cleaning', 'spark'],
    ] },
    { grupo: 'convivencia', items: [
        ['sala_estar', 'living-room', 'sofa'], ['mascotas', 'pets', 'paw'],
    ] },
];

// Equipamiento con cantidad (room-data.json): por habitación o, si no hay, del estudio. [columna, texto (wizard.room.*)]
export const EQUIPO = [
    ['cama_2_plazas', 'two-seater-bed'], ['cama_1_media_plaza', 'one-half-bed'], ['cama_1_plaza', 'single-bed'],
    ['camarote', 'cabin'], ['sofa_cama', 'settee-bed'], ['bano_privado', 'private-bathroom'], ['bano_compartido', 'shared-bathroom'],
    ['escritorio', 'desk-chair'], ['closet', 'closet'], ['velador', 'pedestal-table'], ['colgadores', 'hangers'],
    ['ropa_cama', 'linens'], ['wifi', 'wifi'], ['tv', 'tv'], ['ac', 'air-conditioner'], ['calefaccion', 'heating'],
    ['ventilador', 'fan'], ['secador', 'hair-dryer'],
];

// Cercano a (step6-data.json; acá con el texto correcto: en el wizard viejo
// metro y micro tienen el texto cruzado). [columna, texto (wizard.s6.*), ícono]
export const CERCANO = [
    ['estacion_metro', 'subway-station', 'metro'], ['paradero_micro', 'bus-stop', 'bus'], ['supermercado', 'supermarket', 'cart'],
    ['hospital', 'hospital', 'cross'], ['banco', 'bank', 'bank'], ['centro_comercial', 'mall', 'bag'],
    ['areas_verdes', 'park', 'leaf'], ['gimnasio_externo', 'gym', 'gym'], ['zona_nocturna', 'night', 'moon'],
    ['centro_civico', 'civil-center', 'bank'],
];

// Quiénes viven (step7-data.json). [columna, texto (wizard.s7.*)]
export const HABITANTES = [
    ['hombres', 'men'], ['mujeres', 'women'], ['ninos', 'children'], ['tercera_edad', 'seniors'],
    ['personal_servicio', 'service-staff'], ['perros', 'dogs'], ['gatos', 'cats'], ['otras_mascotas', 'pets'],
];

export const TEXTOS = ['reglas', 'espacios_comunes', 'uso_cocina', 'aseo_limpieza'];

// Monedas de la web (tipo_cambio): se usan mientras no llegó la tabla de cambio.
// Sin ARS: la web no trabaja en pesos argentinos.
export const MONEDAS_RESPALDO = ['USD', 'EUR', 'CLP', 'GBP'];
export const MONEDAS_FUERA = ['ARS'];

/** Categorías que se pueden elegir para un tipo (Banner/Category.json, como Step1Wizard). */
export function categoriasDe(tipo) {
    return categorias.filter(c => (c.owner || []).indexOf(tipo) !== -1);
}

// ── Plata ──
// 4 % + impuesto que se le descuenta al anfitrión del primer mes. Tiene que
// ser igual a PriceService::HF_COMMISSION_RATE del API (y a los Step2).
export const COMISION = 0.0484;
export const COMISION_LABEL = 4;
// Mismo redondeo que PriceService::roundCustom()
export const roundCustom = a => { const p = Math.floor(a); return (a - p) <= 0.49 ? p : Math.ceil(a); };

const SIMB = { USD: '$', CLP: '$', ARS: '$', MXN: '$', COP: '$', EUR: '€', GBP: '£', BRL: 'R$', PEN: 'S/' };
export function dinero(v, moneda) {
    const n = Math.round(+v || 0);
    return `${SIMB[moneda] || ''}${n.toLocaleString('es-CL')} ${moneda || ''}`.trim();
}
export const num = v => { const n = parseFloat(v); return isFinite(n) ? n : 0; };

/** A 1.000 en CLP, ARS y COP; a 10 en el resto (igual que la API). */
export function redondear(v, moneda) {
    const paso = ['CLP', 'ARS', 'COP'].includes(moneda) ? 1000 : 10;
    return Math.round(v / paso) * paso;
}

/**
 * Modelo del anfitrión (lo manda el login, localStorage `modelo` / `modelo_viejo`):
 *  · 'garantia' → modelo nuevo (Step2WizardGarantia): pregunta meses de garantía.
 *  · 'viejo'    → modelo anterior (Step2Wizard con modelo_viejo): H&F cobra un mes de garantía.
 *  · '4'        → modelo provisorio (Step2Wizard): sin garantía, comisión 4 %.
 */
export function modeloAnfitrion() {
    let m = {};
    try { m = JSON.parse(localStorage.getItem('modelo')) || {}; } catch (e) { m = {}; }
    if (m.wizard_garantia) return { tipo: 'garantia', descuenta: m.descuenta_al_anfitrion !== false };
    if (localStorage.getItem('modelo_viejo') === '1') return { tipo: 'viejo', descuenta: false };
    return { tipo: '4', descuenta: true };
}

// Correos, teléfonos y enlaces: no se pueden publicar en los textos.
export const CONTACTO = /(@|\b\d[\d\s.-]{7,}\d\b|https?:\/\/|www\.|wa\.me|whatsapp|instagram)/i;

/** Texto plano → HTML (la ficha lo muestra con v-html). */
export function aHtml(texto) {
    const t = String(texto || '').replace(/\r\n/g, '\n').trim();
    if (!t) return '';
    const esc = x => x.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    return t.split(/\n{2,}/).map(p => `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`).join('');
}

export const clonar = o => JSON.parse(JSON.stringify(o));
export const igual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
